/* HOUSE OF STALONI - video sound toggle (one unmuted video at a time) */
(function () {
  'use strict';
  if (window.__staloniVideoSound) return;
  window.__staloniVideoSound = true;

  var BTN = 'stal-sound-btn';
  var state = new WeakMap();

  var S = 'button.' + BTN + '.' + BTN;
  var css =
    S + '{position:absolute!important;top:auto!important;left:auto!important;right:12px!important;bottom:12px!important;z-index:6!important;' +
    'display:inline-flex!important;align-items:center;gap:6px;width:auto!important;height:auto!important;max-width:calc(100% - 24px)!important;' +
    'aspect-ratio:auto!important;overflow:visible!important;transform:none!important;opacity:1!important;visibility:visible!important;' +
    'min-height:44px!important;min-width:44px!important;padding:0 14px!important;margin:0!important;border:1px solid rgba(201,164,92,.7)!important;border-radius:999px!important;' +
    'background:rgba(0,0,0,.62)!important;color:#fff!important;font:600 14px/1 system-ui,-apple-system,"Segoe UI",Roboto,sans-serif!important;letter-spacing:.02em;text-transform:none!important;' +
    'cursor:pointer;-webkit-tap-highlight-color:transparent;touch-action:manipulation;' +
    'box-shadow:0 2px 10px rgba(0,0,0,.35)!important;pointer-events:auto!important;white-space:nowrap}' +
    S + ':hover{background:rgba(0,0,0,.82)!important}' +
    S + ':focus{outline:none}' +
    S + ':focus-visible{outline:3px solid #fff!important;outline-offset:2px!important;box-shadow:0 0 0 6px rgba(0,0,0,.6)!important}' +
    S + '[hidden]{display:none!important}' +
    S + '.' + BTN + '--top{top:12px!important;bottom:auto!important}' +
    S + ' .stal-sound-ico{font-size:16px;line-height:1}' +
    '@media (max-width:749px){' + S + '{right:10px!important;bottom:10px!important;padding:0 12px!important;font-size:13px!important}' + S + '.' + BTN + '--top{top:10px!important;bottom:auto!important}}';

  function injectCSS() {
    if (document.getElementById('stal-sound-css')) return;
    var s = document.createElement('style');
    s.id = 'stal-sound-css';
    s.textContent = css;
    document.head.appendChild(s);
  }

  /* true = has audio, false = no audio, null = not known yet */
  function hasAudio(v) {
    if (v.readyState < 1) return null;
    if (typeof v.mozHasAudio === 'boolean') return v.mozHasAudio;
    if (v.audioTracks && typeof v.audioTracks.length === 'number') return v.audioTracks.length > 0;
    if (typeof v.webkitAudioDecodedByteCount === 'number') {
      if (v.webkitAudioDecodedByteCount > 0) return true;
      if (v.webkitVideoDecodedByteCount > 0 && v.currentTime > 1) return false;
      return null;
    }
    return true; /* no detection API: show the button */
  }

  function render(v) {
    var s = state.get(v);
    if (!s) return;
    var muted = v.muted || v.volume === 0;
    s.ico.textContent = muted ? '\uD83D\uDD0A' : '\uD83D\uDD07';
    s.txt.textContent = muted ? 'Sound on' : 'Sound off';
    s.btn.setAttribute('aria-label', muted ? 'Sound on: unmute video' : 'Sound off: mute video');
  }

  function muteOthers(keep) {
    document.querySelectorAll('video').forEach(function (o) {
      if (o !== keep && !o.muted) { o.muted = true; render(o); }
    });
  }

  function toggle(v) {
    if (v.muted || v.volume === 0) {
      var wasPlaying = !v.paused;
      muteOthers(v);
      if (v.volume === 0) v.volume = 1;
      v.muted = false;
      if (wasPlaying && v.paused) {
        var p = v.play();
        if (p && p.catch) p.catch(function () { v.muted = true; v.play().catch(function () {}); render(v); });
      }
    } else {
      v.muted = true;
    }
    render(v);
  }

  function evaluate(v) {
    var s = state.get(v);
    if (!s || s.decided) return;
    var h = hasAudio(v);
    if (h === null) return;
    s.decided = true;
    v.removeEventListener('timeupdate', s.onCheck);
    if (h) { s.btn.hidden = false; render(v); }
    else if (s.btn.parentNode) { s.btn.parentNode.removeChild(s.btn); }
  }

  function stop(e) { e.stopPropagation(); }

  function attach(v) {
    if (state.has(v) || v.closest('template')) return;
    var host = v.parentElement;
    if (!host) return;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = BTN + (v.controls ? ' ' + BTN + '--top' : '');
    btn.hidden = true;
    var ico = document.createElement('span');
    ico.className = 'stal-sound-ico';
    ico.setAttribute('aria-hidden', 'true');
    var txt = document.createElement('span');
    btn.appendChild(ico);
    btn.appendChild(txt);

    var s = { btn: btn, ico: ico, txt: txt, decided: false, onCheck: function () { evaluate(v); } };
    state.set(v, s);

    btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); toggle(v); });
    ['pointerdown', 'pointerup', 'mousedown', 'mouseup', 'touchstart', 'touchend', 'keydown', 'keyup'].forEach(function (ev) {
      btn.addEventListener(ev, stop, { passive: true });
    });

    v.addEventListener('volumechange', function () {
      if (!v.muted && v.volume > 0) muteOthers(v);
      render(v);
    });
    v.addEventListener('loadedmetadata', s.onCheck);
    v.addEventListener('playing', s.onCheck);
    v.addEventListener('timeupdate', s.onCheck);

    host.appendChild(btn);
    render(v);
    evaluate(v);
  }

  function scan(root) {
    if (root.tagName === 'VIDEO') { attach(root); return; }
    if (root.querySelectorAll) root.querySelectorAll('video').forEach(attach);
  }

  function init() {
    injectCSS();
    scan(document);
    new MutationObserver(function (list) {
      list.forEach(function (m) {
        m.addedNodes.forEach(function (n) { if (n.nodeType === 1) scan(n); });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
